import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { ImportContacts } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuLearnItem(t0) {
  const $ = _c(14);
  let isSheet;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = rest;
  } else {
    isSheet = $[1];
    rest = $[2];
  }
  const t = useTranslations("MoreMenuLearnItem");
  let t1;
  if ($[3] !== isSheet) {
    t1 = isSheet ? <Button icon={ImportContacts} size="lg" variant="secondary" /> : <MoreMenuItemAvatar icon={ImportContacts} />;
    $[3] = isSheet;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <MoreMenuItemContent><MoreMenuItemTitle>{t2}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isSheet || $[10] !== rest || $[11] !== t1 || $[12] !== t3) {
    t4 = <Link href="https://opensea.io/learn" variant="unstyled"><MoreMenuItem isSheet={isSheet} {...rest}>{t1}{t3}</MoreMenuItem></Link>;
    $[9] = isSheet;
    $[10] = rest;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}